<template>
    <div class="data-coverage-wrapper">
        <div v-if="isLoading" class="data-coverage-loading">
            <PtIcon icon="SolidLoadingBars"/>
        </div>
        <template v-else>
            <div class="data-coverage-map-wrapper">
                <div class="data-coverage-map-content">
                    <div class="data-coverage-map-total-patents">
                        <div class="data-coverage-map-total-patents-title">{{ $t('dataCoverage.totalPatents') }}</div>
                        <FlipCard
                            class="data-coverage-map-total-patents-count"
                            :totalNumber="totalPatent.current"
                            :prevTotalNumber="totalPatent.previous"
                        />
                        <!-- map -->
                        <div class="data-coverage-map-total-patents-map">
                            <img src="./../../assets/map.png"/>
                            <div class="data-coverage-map-total-patents-infos">
                                <div class="data-coverage-map-total-patents-infos-item">
                                    <PtIcon icon="SolidFlag"/>
                                    <div class="data-coverage-map-total-patents-infos-item-title">
                                        {{ $t('dataCoverage.authority') }}
                                    </div>
                                    <div class="data-coverage-map-total-patents-infos-item-count">
                                        {{totalPatent.totalCountry}}
                                    </div>
                                </div>
                                <div class="data-coverage-map-total-patents-infos-item">
                                    <PtIcon icon="SolidTimeRefresh"/>
                                    <div class="data-coverage-map-total-patents-infos-item-title">
                                        {{ $t('dataCoverage.updateFrequency') }}
                                    </div>
                                    <div class="data-coverage-map-total-patents-infos-item-count">
                                        {{ $t('dataCoverage.dailyUpdate') }}
                                    </div>
                                </div>
                                <div class="data-coverage-map-total-patents-infos-item">
                                    <PtIcon icon="Timer"/>
                                    <div class="data-coverage-map-total-patents-infos-item-title">
                                        {{ $t('dataCoverage.lastUpdateDate') }}
                                    </div>
                                    <div class="data-coverage-map-total-patents-infos-item-count">
                                        {{ lastUpdate }}
                                    </div>
                                </div>
                            </div>
                            <div class="data-coverage-map-total-patents-map-dots">
                                <ElPopover
                                    v-for="(item,index) in dotList"
                                    :key="index"
                                    :value="loopDot===item.code"
                                    trigger="manual"
                                    placement="top"
                                    popper-class="data-coverage-map-total-patents-map-dots-item-tips"
                                >
                                    <div class="dots-tip-wrapper">
                                        <div class="dots-tip-header">
                                            <div class="dots-tip-left">
                                                <span :class="['flag-authority', 'flag-authority--'+ item.code.substr(0,2)]"></span>
                                            </div>
                                            <span class="country-name">{{ getCountryName(item.code) }}</span>
                                        </div>
                                        <div class="dots-tip-content" v-if="item.increment>0">
                                            <div class="dots-tip-left ">
                                                <div class="arrow-tail-up-wrapper">
                                                    <PtIcon icon="SolidArrowTailUp" class="arrow-animation"
                                                            :class="{'arrow-animation-start':hoverDot===item.code}"/>
                                                    <PtIcon icon="SolidArrowTailUp" class="arrow-animation"
                                                            :class="{'arrow-animation-start':hoverDot===item.code}"/>
                                                </div>
                                            </div>
                                            <div class="dots-tip-content-increment">{{ numberFormatUtil(item.increment) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        :style="{left:item.left+'px',top:item.top+'px'}"
                                        :class="[`animate__zoom__${index}`,{'no-animate':hoverDot===item.code || loopDot===item.code}]"
                                        class="data-coverage-map-total-patents-map-dots-item animate__zoom"
                                        slot="reference"
                                        @mouseenter="handleMouseEnterDot(index)"
                                        @mouseleave="handleMouseLeaveDot"
                                        @click="showIncreaseChartDialog(item)"
                                    />
                                </ElPopover>
                            </div>
                            <div
                                class="data-coverage-map-total-patents-more">
                                <span class="animate__bounce" @click="scrollIntoContent">
                                    <span class="data-coverage-map-total-patents-more-text">
                                        {{ $t('dataCoverage.more') }}
                                    </span>
                                    <PtIcon icon="SolidDoubleArrowDown"/>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="data-coverage-content-wrapper">
                <div class="data-coverage-tabs-wrapper">
                    <div class="data-coverage-tabs">
                        <div
                            v-for="(item) in tabs"
                            :key="item.type"
                            :class="{'active': currentTab===item.type}"
                            @click="handleChangeTabs(item.type)"
                            class="data-coverage-tabs-item"
                        >
                            <div class="data-coverage-tabs-item-header">
                                <PtIcon
                                    :icon="item.icon"
                                />
                                <div class="data-coverage-tabs-item-name">
                                    {{$t(`dataCoverage.nav.${item.type}`)}}
                                </div>
                            </div>
                            <div class="data-coverage-tabs-item-content">
                                <div class="data-coverage-tabs-item-count">
                                    <ScrollNum :totalNumber="item.count"/>
                                </div>
                                <div class="data-coverage-tabs-item-unit">{{ item.unit }}
                                </div>
                                <div class="data-coverage-tabs-item-increment"
                                     v-if="item.increment>0">
                                    <div class="arrow-tail-up-wrapper">
                                        <PtIcon icon="SolidArrowTailUp" class="arrow-animation"/>
                                        <PtIcon icon="SolidArrowTailUp" class="arrow-animation"/>
                                    </div>
                                    {{ numberFormatUtil(item.increment) }}
                                    <span
                                        class="tips-wrapper"
                                    >
                                         <ElTooltip
                                             effect="light"
                                             placement="top"
                                             :enterable="false"
                                             :content="$t(`dataCoverage.nav.${item.type}Tips`)"
                                             :visible-arrow="false"
                                             popper-class="global-patent-databases-table-tips"
                                         >
                                            <PtIcon icon="SolidInfo"/>
                                         </ElTooltip>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <GlobalPatentDatabases v-show="currentTab==='globalPatentDatabases'" :officialLinks="officialLinks"/>
                <LegalDatabases v-show="currentTab==='legalDatabases'"/>
                <LiteratureDatabase :data="nplData" v-show="currentTab==='literatureDatabase'"/>
            </div>
            <IncreaseChartDialog
                v-if="increaseChartInfo.visible"
                :data="increaseChartInfo.data"
                :visible.sync="increaseChartInfo.visible"
                @close="closeIncreaseChartDialog"
            />
            <div v-if="backToTopBtnVisible" class="back-to-top" @click="backToTop">
                <PtIcon icon="SolidBackToTop"/>
            </div>
        </template>
    </div>
</template>

<script>
import GlobalPatentDatabases from './components/GlobalPatentDatabases';
import LegalDatabases from './components/LegalDatabases';
import LiteratureDatabase from './components/LiteratureDatabase';

import { Icon as PtIcon } from 'patsnap-biz';
import { Popover, Tooltip } from 'element-ui';
import ScrollNum from '../../components/scroll-num/index';
import { numberFormatUtil, scrollTo, transitionNumber } from '../../util/index';
import { get, map, throttle } from 'lodash';
import { RavenInsertMeta } from 'library-@/services/sentry';
import dayjs from 'dayjs';

import {
    getNplDataSourceApi,
    getOverviewInfo,
} from '../../../../../../../../components/apis/core_basic_api/data_coverage';
import '@patsnap-ui/icon/assets/solid/info.svg';
import '@patsnap-ui/icon/assets/solid/flag.svg';
import '@patsnap-ui/icon/assets/solid/TimeRefresh.svg';
import '@patsnap-ui/icon/assets/solid/Timer.svg';
import '@patsnap-ui/icon/assets/solid/InsightsTechnology.svg';
import '@patsnap-ui/icon/assets/solid/notebook.svg';
import '@patsnap-ui/icon/assets/solid/ArrowTailUp.svg';
import '@patsnap-ui/icon/assets/solid/DoubleArrowDown.svg';
import '@patsnap-ui/icon/assets/solid/InsightsExaminelitigationhistoryNew.svg';
import '@patsnap-ui/icon/assets/solid/BackToTop.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

import IncreaseChartDialog from './components/IncreaseChartDialog';
import countryDb from 'library-@/config/country';
import FlipCard from '../../components/flip-card/FlipCard';

/**
 * 数据范围
 */
export default {
    components: {
        FlipCard,
        IncreaseChartDialog,
        PtIcon,
        GlobalPatentDatabases,
        LegalDatabases,
        LiteratureDatabase,
        ElPopover: Popover,
        ElTooltip: Tooltip,
        ScrollNum
    },
    computed: {
        lastUpdate() {
            const formatMap = {
                cn: 'YYYY-MM-DD',
                tw: 'YYYY-MM-DD',
                en: 'DD MMM YYYY',
                jp: 'YYYY.MM.DD'
            };
            const formatType = formatMap[this.$i18n.locale || 'cn'];
            return dayjs().format(formatType);
        }
    },
    data() {
        return {
            overview: {},
            tabs: [],
            currentTab: '',
            totalNplNumber: 0,
            nplData: {},
            hasNpl: false,
            dotList: [
                { code: 'US', increment: 0, left: 235, top: 193, },
                { code: 'FR', increment: 0, left: 446, top: 178, },
                { code: 'DE', increment: 0, left: 460, top: 153, },
                { code: 'WO', increment: 0, left: 475, top: 174, },
                { code: 'EP', increment: 0, left: 488, top: 151, },
                { code: 'CN', increment: 0, left: 729, top: 188, },
                { code: 'KR', increment: 0, left: 770, top: 195, },
                { code: 'AU', increment: 0, left: 789, top: 347, },
                { code: 'JP', increment: 0, left: 796, top: 195, },
            ],
            // hover的点
            hoverDot: '',
            // 轮询的点
            loopDot: '',
            totalPatent: {
                current: 0,
                previous: 0,
                totalCountry: 0,
            },
            increaseChartInfo: {
                visible: false,
                data: {}
            },
            t: null,
            backToTopBtnVisible: false,
            officialLinks: '',
            isLoading: false,
        };
    },
    methods: {
        numberFormatUtil,
        getCountryName(country) {
            return get(countryDb, `${country}.${this.$i18n.locale}`, country);
        },
        closeIncreaseChartDialog() {
            this.increaseChartInfo = {
                data: {},
                visible: false,
            };
            this.loopDots();
        },
        showIncreaseChartDialog(item) {
            if (this.t) {
                this.loopDot = '';
                this.hoverDot = '';
                clearInterval(this.t);
            }
            item.title = this.$t('dataCoverage.increaseChartDialog.title', {
                name: this.getCountryName(item.code),
                code: item.code
            });
            this.increaseChartInfo = {
                data: item,
                visible: true,
            };
            RavenInsertMeta('Data Coverage', 'Click Data Growth Trend');
        },
        handleChangeTabs(type) {
            this.currentTab = type;
            if (type === 'globalPatentDatabases') {
                RavenInsertMeta('Data Coverage', 'Click Patent Database');
            } else if (type === 'legalDatabases') {
                RavenInsertMeta('Data Coverage', 'Click Legal Database');
            } else if (type === 'literatureDatabase') {
                RavenInsertMeta('Data Coverage', 'Click Literature Database');
            }
        },
        getArticle() {
            if (!this.hasNpl) return;
            getNplDataSourceApi()
                .then((data) => {
                    const baseOverview = get(data, 'overview', null);
                    const overview = {
                        sourceLabel: 'Microsoft Academic',
                        total: baseOverview.total,
                        abstractCount: baseOverview.has_abstract,
                        pdfCount: baseOverview.has_pdf
                    };
                    const currentPubList = map(get(data, 'publication_list', []), item => ({
                        name: get(item, 'metadata.name', ''),
                        count: item.value || 0
                    }));

                    this.tabs[2].increment = get(data, 'increment', 0);
                    const formatInfo = transitionNumber(get(data, 'total_number', 0));
                    this.tabs[2].count = formatInfo.count;
                    this.tabs[2].unit = formatInfo.unit;

                    this.nplData = {
                        overview,
                        currentPubList,
                        last_updated: data.last_updated || '',
                        update_frequency: data.update_frequency || '',
                        total_number: data.total_number || 0
                    };
                });
        },
        loopDots() {
            let index = 0;
            this.t = setInterval(() => {
                this.loopDot = this.dotList[index % this.dotList.length].code;
                index++;
            }, 3 * 1000);
        },
        handleMouseEnterDot(index) {
            clearInterval(this.t);
            this.hoverDot = this.loopDot = this.dotList[index].code;
        },
        handleMouseLeaveDot() {
            this.loopDot = '';
            this.hoverDot = '';
            if (!this.increaseChartInfo.visible) {
                this.loopDots();
            }
        },
        scrollIntoContent() {
            const height = document.querySelector('.data-coverage-map-wrapper')?.clientHeight || 0;
            scrollTo(document.querySelector('.app-container'), height);
        },
        onScroll() {
            let scrollTop = document.querySelector('.app-container').scrollTop;
            if (scrollTop === 0) {
                this.backToTopBtnVisible = false;
            } else {
                this.backToTopBtnVisible = true;
            }
        },
        backToTop() {
            scrollTo(document.querySelector('.app-container'), 0);
        },
        async getOverview() {
            this.isLoading = true;
            try {
                let overview = await getOverviewInfo();
                const hasNpl = get(overview, 'nplDataCoverage', false);
                const formatGlobalInfo = transitionNumber(get(overview, 'overview.patent_total_count', 0));
                const formatLegalInfo = transitionNumber(get(overview, 'overview.legal_total_count', 0));
                let tabs = [
                    {
                        type: 'globalPatentDatabases',
                        icon: 'SolidInsightsTechnology',
                        count: formatGlobalInfo.count,
                        unit: formatGlobalInfo.unit,
                        increment: get(overview, 'overview.patent_update_count', 0),
                    },
                    {
                        type: 'legalDatabases',
                        icon: 'SolidInsightsExaminelitigationhistoryNew',
                        count: formatLegalInfo.count,
                        unit: formatLegalInfo.unit,
                        increment: get(overview, 'overview.legal_update_count', 0),
                    }
                ];
                const totalPatent = {
                    current: get(overview, 'overview.patent_total_count', 0),
                    previous: get(overview, 'overview.last_patent_total_count', 0),
                    totalCountry: get(overview, 'overview.total_country', 0),
                };
                hasNpl && tabs.push({
                    type: 'literatureDatabase',
                    icon: 'SolidNotebook',
                    count: 0,
                    increment: 0,
                    unit: '',
                });
                this.overview = overview;
                this.tabs = tabs;
                this.currentTab = tabs[0].type;
                this.totalPatent = totalPatent;
                this.hasNpl = hasNpl;
                this.officialLinks = get(overview, 'officialLinks.EPO', '');
                this.dotList.forEach(dot => {
                    dot.increment = get(this.overview, `overview.mapList.${dot.code}`, 0);
                });
                this.getArticle();
            } finally {
                this.isLoading = false;
            }
        }
    },
    async created() {
        this.getOverview();
        RavenInsertMeta('Data Coverage', 'View Data Coverage');
    },
    mounted() {
        this.$nextTick(() => {
            this.loopDots();
            this.debounceOnScroll = throttle(this.onScroll, 30);
            document.querySelector('.app-container').addEventListener('scroll', this.debounceOnScroll);
        });

    },
    beforeDestroy() {
        document.querySelector('.app-container').removeEventListener('scroll', this.debounceOnScroll);
    },
};
</script>

<style lang="scss">
.arrow-tail-up-wrapper {
    display: flex;
    flex-direction: column;
    width: 16px;
    height: 16px;
    margin: 0 auto;
    overflow: hidden;

    .patsnap-biz-icon {
        &[icon="SolidArrowTailUp"] {
            flex-shrink: 0;

            &.arrow-animation-start {
                -webkit-animation: slideInUp 1.5s infinite;
                animation: slideInUp 1.5s infinite;
            }
        }
    }
}

.data-coverage-map-total-patents-map-dots-item-tips {
    margin-bottom: 16px !important;
    min-width: 0;
    padding: 8px 16px;
    z-index: 10 !important;
    white-space: nowrap;

    .dots-tip-header {
        display: flex;
        align-items: center;
    }

    .country-name {
        margin-left: 8px;
        height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #000000;
    }

    .dots-tip-content {
        margin-top: 2px;
        font-size: 0;
        display: flex;
        align-items: center;

        .dots-tip-content-increment {
            margin-left: 8px;
            font-size: 16px;
            font-weight: 600;
            color: #33B900;
        }
    }

    .patsnap-biz-icon {
        margin-bottom: 0;

        &[icon="SolidArrowTailUp"] {
            fill: #33B900 !important;
            font-size: 16px;
        }
    }

    .dots-tip-left {
        width: 24px;
        text-align: center;
    }
}

.data-coverage-wrapper {
    position: relative;
    height: 100%;
    .data-coverage-loading{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .patsnap-biz-icon {
            font-size: 48px !important;
            fill: $fill-normal !important;
        }
    }
    .data-coverage-map-wrapper {
        min-width: 1280px;
        padding-top: 30px;
        height: 590px;
        background: linear-gradient(360deg, #E7F2F2 0%, #FFFFFF 90%);
    }

    .patsnap-biz-icon {
        margin-right: 4px;

        &[icon="SolidArrowTailUp"] {
            fill: #33B900 !important;
            font-size: 16px;
            margin-right: 0;
        }
    }

    .data-coverage-map-content {
        width: 1280px;
        margin: 0 auto;
        text-align: center;

        .data-coverage-map-total-patents {
            &-title {
                height: 20px;
                font-size: 14px;
                font-weight: 400;
                color: $text-secondary;
                line-height: 20px;
            }

            &-count {
                color: $green-primary;
                height: 58px;
                font-size: 42px;
                font-weight: 800;
                line-height: 58px;
            }

            &-infos {
                position: absolute;
                top: 0;
                display: flex;
                justify-content: space-between;
                width: 967px;

                &-item {
                    display: flex;
                    flex: 1;
                    align-items: center;
                    justify-content: center;


                    &-title {
                        height: 20px;
                        font-size: 14px;
                        font-weight: 400;
                        color: $text-secondary;
                        margin-right: 8px;
                    }

                    &-count {
                        height: 20px;
                        font-size: 14px;
                        font-weight: 600;
                        color: $green-primary;
                    }
                }
            }

            &-map {
                margin: 30px auto 0;
                position: relative;
                width: 967px;
                height: 520px;

                img {
                    width: 967px;
                    height: 520px;
                }

                &-dots {
                    &-item {
                        position: absolute;
                        width: 16px;
                        height: 16px;
                        background: #0FB600;
                        border-radius: 50%;
                        cursor: pointer;
                        z-index: 3;

                        &:before {
                            position: absolute;
                            top: 5px;
                            left: 5px;
                            display: inline-block;
                            content: "";
                            width: 6px;
                            height: 6px;
                            background: #0B8D00;
                            border-radius: 50%;
                            z-index: 2;
                        }

                        &:after {
                            position: absolute;
                            top: -6px;
                            left: -6px;
                            display: inline-block;
                            content: "";
                            width: 16px;
                            height: 16px;
                            background: transparent;
                            border: 6px solid rgba(96, 218, 0, 0.5);
                            border-radius: 50%;
                            z-index: 1;
                        }
                    }
                }
            }

            &-more {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 80px;
                display: flex;
                align-items: center;
                justify-content: center;

                .animate__bounce {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                }

                &-text {
                    font-size: 12px;
                    font-weight: 400;
                    color: $text-hint;
                }

                .patsnap-biz-icon {
                    &[icon="SolidDoubleArrowDown"] {
                        font-size: 16px;
                        fill: $text-hint !important;
                    }
                }
            }
        }
    }

    .data-coverage-content-wrapper {
        min-width: 1280px;
        margin: 0 auto;
    }

    .data-coverage-tabs-wrapper {
        margin: 0 auto;
        padding: 10px 0 20px;
        z-index: 20;
        position: sticky;
        top: 0px;

        &:before, &:after {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
        }

        &:before {
            height: 50px;
            top: 0;
            background: #E7F2F2;
        }

        &:after {
            height: 60px;
            bottom: 0;
            background: $bg-white;
        }
    }

    .data-coverage-tabs {
        display: flex;
        justify-content: center;


        &-item {
            z-index: 10;
            width: 320px;
            height: 80px;
            display: flex;
            flex-direction: column;
            background: linear-gradient(131deg, #EBF0ED 0%, #FAFAFA 100%);
            box-shadow: 5px 5px 15px 0px #E2E2E2B2;
            border-radius: 8px;
            margin-right: 40px;
            padding: 10px 0 10px 16px;
            cursor: pointer;
            outline: 2px solid transparent;
            box-sizing: border-box;

            &:last-child {
                margin-right: 0;
            }

            &:hover {
                &:not(.active) {
                    background: linear-gradient(100deg, #60E12F 0%, #60E12F 0%, #60E12F 0%, #00A6DA 100%);
                    box-shadow: 5px 5px 15px 0px #E2E2E2B2;

                    .data-coverage-tabs-item-name, .data-coverage-tabs-item-count, .data-coverage-tabs-item-unit, .scroll-num {
                        color: $bg-white;
                    }

                    .data-coverage-tabs-item-increment {
                        border-radius: 4px;
                        background: $bg-white;
                    }

                    .patsnap-biz-icon {
                        fill: $text-white;
                    }

                    .arrow-tail-up-wrapper {
                        .arrow-animation {
                            -webkit-animation: slideInUp 1.5s infinite;
                            animation: slideInUp 1.5s infinite;
                        }
                    }
                }

            }

            &.active {
                outline: 2px solid rgba(69, 163, 33, 0.5);
                background: $bg-white;
                box-shadow: none;
            }

            &-header, &-content {
                display: flex;
                align-items: center;
            }

            &-content {
                margin-top: 4px;
            }

            &-name {
                height: 22px;
                font-size: 16px;
                color: #B3BAC5;
            }

            &-count {
                margin: 0 8px 0 28px;
                height: 32px;
                line-height: 32px;
                font-size: 24px;
                font-weight: 600;
                color: $text-primary;
            }

            &-unit {
                margin-right: 18px;
                height: 20px;
                line-height: 20px;
                font-weight: 400;
                color: #B3BAC5;
            }

            &-increment {
                padding: 4px;
                height: 26px;
                line-height: 26px;
                font-size: 14px;
                font-weight: 600;
                color: #33B900;
                display: flex;
                align-items: center;
            }
            .patsnap-biz-icon {
                &[icon="SolidInfo"] {
                    fill: #33B900 !important;
                }
            }
        }
    }

    @-webkit-keyframes slideInUp {
        0% {
            -webkit-transform: translateY(0px);
            transform: translateY(0px);
        }
        100% {
            -webkit-transform: translateY(-16px);
            transform: translateY(-16px);
        }
    }
    @keyframes slideInUp {
        0% {
            -webkit-transform: translateY(0px);
            transform: translateY(0px);
        }
        100% {
            -webkit-transform: translateY(-16px);
            transform: translateY(-16px);
        }
    }

    @-webkit-keyframes zoom {
        from {
            opacity: 1;
        }
        50% {
            opacity: 0.2;
            -webkit-transform: scale3d(1.5, 1.5, 1.5);
            transform: scale3d(1.5, 1.5, 1.5);
        }
    }
    @keyframes zoom {
        from {
            opacity: 1;
        }
        50% {
            opacity: 0.2;
            -webkit-transform: scale3d(1.5, 1.5, 1.5);
            transform: scale3d(1.5, 1.5, 1.5);
        }
    }

    .no-animate {
        -webkit-animation-name: none !important;
        animation: none !important;
    }

    .animate__zoom {
        -webkit-animation: zoom 3s infinite;
        animation: zoom 3s infinite;

        &.animate__zoom__2,
        &.animate__zoom__7 {
            animation-delay: 0s;
        }

        &.animate__zoom__3,
        &.animate__zoom__5 {
            animation-delay: 2s;
        }

        &.animate__zoom__1,
        &.animate__zoom__8 {
            animation-delay: 1.5s;
        }

        &.animate__zoom__0 ,
        &.animate__zoom__4{
            animation-delay: 0.5s;
        }

        &.animate__zoom__6 {
            animation-delay: 1s;
        }
    }

    /*animate*/
    /* Attention seekers  */
    @-webkit-keyframes bounce {
        from,
        20%,
        53%,
        to {
            -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        40%,
        43% {
            -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            -webkit-transform: translate3d(0, -20px, 0) scaleY(1.1);
            transform: translate3d(0, -20px, 0) scaleY(1.1);
        }

        55% {
            -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            -webkit-transform: translate3d(0, -10px, 0) scaleY(1.05);
            transform: translate3d(0, -10px, 0) scaleY(1.05);
        }

        60% {
            -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            -webkit-transform: translate3d(0, 0, 0) scaleY(0.95);
            transform: translate3d(0, 0, 0) scaleY(0.95);
        }

        65% {
            -webkit-transform: translate3d(0, -4px, 0) scaleY(1.02);
            transform: translate3d(0, -4px, 0) scaleY(1.02);
        }

        70%,80%, 90%, 100% {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }
    @keyframes bounce {
        from,
        20%,
        53%,
        to {
            -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        40%,
        43% {
            -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            -webkit-transform: translate3d(0, -20px, 0) scaleY(1.1);
            transform: translate3d(0, -20px, 0) scaleY(1.1);
        }

        55% {
            -webkit-animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
            -webkit-transform: translate3d(0, -10px, 0) scaleY(1.05);
            transform: translate3d(0, -10px, 0) scaleY(1.05);
        }

        60% {
            -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            -webkit-transform: translate3d(0, 0, 0) scaleY(0.95);
            transform: translate3d(0, 0, 0) scaleY(0.95);
        }

        65% {
            -webkit-transform: translate3d(0, -4px, 0) scaleY(1.02);
            transform: translate3d(0, -4px, 0) scaleY(1.02);
        }

        70%, 80%, 90%, 100% {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }


    .animate__bounce {
        -webkit-animation: 4s bounce infinite;
        animation: 4s bounce infinite;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-transform-origin: center bottom;
        transform-origin: center bottom;
    }

    .back-to-top {
        position: fixed;
        bottom: 30px;
        right: 20px;
        cursor: pointer;
        border-radius: 50%;
        width: 46px;
        height: 46px;
        background: $bg-white;
        box-shadow: 0px 5px 30px 0px rgba(0, 40, 2, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 20;

        .patsnap-biz-icon {
            fill: $fill-normal;
            margin-right: 0;
        }
    }

    .global-patent-databases-table,
    .literature-database-table,
    .legal-databases-table {
        width: 100%;
        text-align: left;

        thead {
            border: 1px solid #ebecf0;
            background: linear-gradient(180deg, #eff1ef, #fdfdfd);
            border-radius: 4px;
            box-sizing: border-box;

            tr {
                th {
                    position: relative;
                    line-height: 20px;
                    font-size: 14px;
                    font-weight: 600;
                    color: #020a1a;
                    padding: 8px;
                    vertical-align: top;
                    white-space: inherit;
                    word-break: break-word;
                    &.common-tips{
                        text-align: center;
                        .patsnap-biz-icon{
                            &[icon="SolidInfo"]{
                                margin: 0;
                            }
                        }
                    }
                }
            }
        }

        tbody {
            tr {
                &.row--stripe {
                    background: #f8f8f8;
                }

                td {
                    font-size: 14px;
                    font-weight: 400;
                    color: #061632;
                    line-height: 20px;
                    padding: 8px;
                }
            }
        }
    }
}
</style>
